module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "task-config"
  }, [_c('headerBlock', {
    attrs: {
      "authUser": _vm.authUser,
      "access_token": _vm.access_token
    },
    on: {
      "logout": function($event) {
        return _vm.onLogout(false)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('uploading', {
    attrs: {
      "uploaded": _vm.upload.uploaded,
      "total": _vm.upload.total,
      "visible": _vm.upload.visible,
      "image": _vm.upload.image
    }
  }), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertError.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertError, "visible", $$v)
      },
      expression: "alertError.visible"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertError.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertError.text))])]), _vm._v(" "), _c('alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "success",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.alertSuccess.visible),
      callback: function($$v) {
        _vm.$set(_vm.alertSuccess, "visible", $$v)
      },
      expression: "alertSuccess.visible"
    }
  }, [_c('span', {
    staticClass: "icon-ok-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.alertSuccess.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.alertSuccess.text))])]), _vm._v(" "), _c('spinner', {
    ref: "spinner",
    attrs: {
      "global": "",
      "size": "lg",
      "fixed": "",
      "text": "Loading..."
    },
    model: {
      value: (_vm.processLoading),
      callback: function($$v) {
        _vm.processLoading = $$v
      },
      expression: "processLoading"
    }
  }), _vm._v(" "), (_vm.duplicate) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [(!_vm.duplicate && _vm.taskId) ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.duplicateTask(true)
      }
    }
  }, [_vm._v("\n          Duplicate\n        ")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveTask(true)
      }
    }
  }, [_vm._v("\n          Save and add another\n        ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveTask()
      }
    }
  }, [_vm._v("\n          Save task\n        ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.deleteTask()
      }
    }
  }, [_vm._v("\n          Delete task\n        ")])], 1)]), _vm._v(" "), _c('h2', [_vm._v("Basic information")]), _vm._v(" "), _c('div', {
    staticClass: "basic-info"
  }, [_c('div', {
    class: [(_vm.needFill && !_vm.formData.name) ? 'has-danger' : '', 'row basic-info__title']
  }, [_vm._m(2), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-md-9",
    attrs: {
      "type": "text",
      "placeholder": (_vm.formData.name) ? '' : 'Enter task title',
      "maxlength": "255"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    class: [(_vm.needFill && !_vm.formData.description) ? 'has-danger' : '', 'row']
  }, [_vm._m(3), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.description),
      expression: "formData.description"
    }],
    staticClass: "col-md-12 basic-info__description form-control",
    attrs: {
      "textarea": "",
      "placeholder": "Enter task description"
    },
    domProps: {
      "value": (_vm.formData.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "description", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row basic-info__title"
  }, [_vm._m(4), _vm._v(" "), _c('b-form-select', {
    staticClass: "col-md-9",
    attrs: {
      "options": _vm.userRoles,
      "value-field": "id",
      "text-field": "name"
    },
    model: {
      value: (_vm.formData.role),
      callback: function($$v) {
        _vm.$set(_vm.formData, "role", $$v)
      },
      expression: "formData.role"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    class: [(_vm.needFill && _vm.formData.video_require) ? 'has-danger' : '']
  }, [_c('p', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Upload main task\n            "), _c('span', {
    staticClass: "underline pointer image-video",
    class: {
      'image-video_active': _vm.formData.selectedContent == 'image'
    },
    on: {
      "click": function($event) {
        _vm.formData.selectedContent = 'image'
      }
    }
  }, [_vm._v("image")]), _vm._v("\n            or "), _c('span', {
    staticClass: "underline pointer image-video",
    class: {
      'image-video_active': _vm.formData.selectedContent == 'video'
    },
    on: {
      "click": function($event) {
        _vm.formData.selectedContent = 'video'
      }
    }
  }, [_vm._v("video")])]), _vm._v("\n          (if none, default icon will be used)\n        ")]), _vm._v(" "), (_vm.formData.selectedContent == 'image') ? _c('thumbnail', {
    attrs: {
      "picture": _vm.formData.picture,
      "picture_url": _vm.formData.img
    },
    on: {
      "update:picture": function($event) {
        return _vm.$set(_vm.formData, "picture", $event)
      },
      "update:picture_url": function($event) {
        return _vm.$set(_vm.formData, "img", $event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formData.selectedContent == 'video') ? [_c('div', {
    staticClass: "col-md-7",
    class: [(_vm.needFill && _vm.formData.video_require) ? 'form-control' : '']
  }, [_c('thumbnail', {
    attrs: {
      "picture": _vm.formData.video_thumbnail,
      "picture_url": _vm.formData.img_thumbnail
    },
    on: {
      "update:picture": function($event) {
        return _vm.$set(_vm.formData, "video_thumbnail", $event)
      },
      "update:picture_url": function($event) {
        return _vm.$set(_vm.formData, "img_thumbnail", $event)
      }
    }
  }), _vm._v(" "), _c('b-form-file', {
    ref: "videofile",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "accept": ".mp4, .mov",
      "choose-label": (!_vm.formData.video && !_vm.formData.video_url) ? 'Choose video' : 'Remove video',
      "placeholder": _vm.formData.video_url
    },
    on: {
      "change": function($event) {
        return _vm.handleVideoFileChange($event)
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearVideo($event)
      }
    },
    model: {
      value: (_vm.formData.video),
      callback: function($$v) {
        _vm.$set(_vm.formData, "video", $$v)
      },
      expression: "formData.video"
    }
  })], 1)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "row align-items-baseline"
  }, [_c('b-form-checkbox', {
    staticClass: "col-md-3",
    attrs: {
      "value": true,
      "unchecked-value": false
    },
    on: {
      "change": function($event) {
        return _vm.updateDeeplinkData()
      }
    },
    model: {
      value: (_vm.formData.deeplink.active),
      callback: function($$v) {
        _vm.$set(_vm.formData.deeplink, "active", $$v)
      },
      expression: "formData.deeplink.active"
    }
  }, [_c('b', [_vm._v("Deeplink to")])]), _vm._v(" "), (_vm.formData.deeplink.active) ? [_c('b-form-select', {
    staticClass: "col-md-3",
    attrs: {
      "options": _vm.deeplinks,
      "value-field": "name",
      "text-field": "name"
    },
    nativeOn: {
      "change": function($event) {
        return _vm.clearDeeplinkId()
      }
    },
    model: {
      value: (_vm.formData.deeplink.item),
      callback: function($$v) {
        _vm.$set(_vm.formData.deeplink, "item", $$v)
      },
      expression: "formData.deeplink.item"
    }
  }), _vm._v(" "), _c('span', {
    class: [_vm.formData.deeplink.badId ? 'has-danger' : '']
  }, [_c('div', {
    staticClass: "col-md-11"
  }, [_c('b-form-input', {
    staticClass: "col-md-12",
    attrs: {
      "type": "number",
      "id": "deeplink-id",
      "placeholder": "Enter numeric ID",
      "state": _vm.formData.deeplink.badId ? 'danger' : ''
    },
    on: {
      "change": function($event) {
        return _vm.checkDeeplinkId()
      }
    },
    nativeOn: {
      "keyup": function($event) {
        return _vm.checkDeeplinkId()
      }
    },
    model: {
      value: (_vm.formData.deeplink.id),
      callback: function($$v) {
        _vm.$set(_vm.formData.deeplink, "id", $$v)
      },
      expression: "formData.deeplink.id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "1px",
      "margin-left": "15px"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.formData.deeplink.name) + "\n          ")])])] : _vm._e()], 2)]), _vm._v(" "), _c('div', {
    staticClass: "instructions"
  }, [_c('h2', [_vm._v("Instructions")]), _vm._v(" "), _c('p', [_vm._v("Enter instructions for the task that will appear in the app for this task. If left blank no instructions for this task will be shown.")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-5"
  }, [_c('b-form-file', {
    ref: "pdffile",
    attrs: {
      "choose-label": (!_vm.formData.description_file && !_vm.formData.description_file_url) ? 'Choose PDF file' : 'Remove PDF file',
      "accept": ".pdf",
      "placeholder": _vm.formData.description_file_url
    },
    nativeOn: {
      "click": function($event) {
        return _vm.clearPdfFile($event)
      },
      "change": function($event) {
        return _vm.changePdfFile($event)
      }
    },
    model: {
      value: (_vm.formData.description_file),
      callback: function($$v) {
        _vm.$set(_vm.formData, "description_file", $$v)
      },
      expression: "formData.description_file"
    }
  })], 1)]), _vm._v(" "), (_vm.formData.instructionSteps.length == 0) ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.formData.description_file && !_vm.formData.description_file_url),
      expression: "!formData.description_file && !formData.description_file_url"
    }],
    staticClass: "instructions__step"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "instructions__step-buttons"
  }, [_c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.addNewStep
    }
  }, [_vm._v("Add steps")])], 1)])])])] : _vm._e(), _vm._v(" "), _vm._l((_vm.formData.instructionSteps), function(item, index) {
    return [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.formData.description_file && !_vm.formData.description_file_url),
        expression: "!formData.description_file && !formData.description_file_url"
      }],
      staticClass: "instructions__step"
    }, [_c('div', {
      staticClass: "row align-items-baseline"
    }, [_vm._m(6, true), _vm._v(" "), _vm._m(7, true), _vm._v(" "), _c('div', {
      class: [(!item.valid) ? 'has-danger' : '', 'col-md-1']
    }, [_c('b-form-input', {
      staticStyle: {
        "width": "55px"
      },
      attrs: {
        "type": "number"
      },
      on: {
        "change": function($event) {
          return _vm.validateSteps()
        }
      },
      model: {
        value: (item.order),
        callback: function($$v) {
          _vm.$set(item, "order", $$v)
        },
        expression: "item.order"
      }
    })], 1), _vm._v(" "), _c('p', {
      staticClass: "col-md-3 offset-md-3"
    }, [_c('b', [_vm._v("Attach\n              "), _c('span', {
      staticClass: "underline pointer image-video",
      class: {
        'image-video_active': item.selectedContent == 'image'
      },
      on: {
        "click": function($event) {
          item.selectedContent = 'image'
        }
      }
    }, [_vm._v("photo")]), _vm._v("\n              or\n              "), _c('span', {
      staticClass: "underline pointer image-video",
      class: {
        'image-video_active': item.selectedContent == 'video'
      },
      on: {
        "click": function($event) {
          item.selectedContent = 'video'
        }
      }
    }, [_vm._v("video")])])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [(!item.valid) ? _c('div', {
      staticClass: "col-md-5 offset-md-3",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("\n              Please enter a number that is not used\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-7"
    }, [_c('span', {
      class: [(_vm.needFill && !item.description) ? 'has-danger' : '']
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.description),
        expression: "item.description"
      }],
      staticClass: " instructions__step-text form-control",
      attrs: {
        "placeholder": "Enter step description"
      },
      domProps: {
        "value": (item.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "description", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "instructions__step-buttons"
    }, [(index == _vm.formData.instructionSteps.length - 1) ? _c('b-button', {
      attrs: {
        "variant": "primary"
      },
      on: {
        "click": _vm.addNewStep
      }
    }, [_vm._v("Add one more step")]) : _vm._e(), _vm._v(" "), (index != _vm.formData.instructionSteps.length - 1) ? _c('div') : _vm._e(), _vm._v(" "), (_vm.formData.instructionSteps.length) ? _c('b-button', {
      attrs: {
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.removeStep(index)
        }
      }
    }, [_vm._v("Remove this step")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
      staticClass: "col-md-5",
      class: [(_vm.needFill && item.video_require) ? 'has-danger' : '']
    }, [(item.selectedContent == 'image') ? _c('thumbnail', {
      attrs: {
        "picture": item.picture,
        "picture_url": item.img
      },
      on: {
        "update:picture": function($event) {
          return _vm.$set(item, "picture", $event)
        },
        "update:picture_url": function($event) {
          return _vm.$set(item, "img", $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), (item.selectedContent == 'video') ? [_c('div', {
      staticClass: "row ",
      class: [(_vm.needFill && item.video_require) ? 'form-control' : '']
    }, [_c('thumbnail', {
      attrs: {
        "picture": item.video_thumbnail,
        "picture_url": item.img_thumbnail
      },
      on: {
        "update:picture": function($event) {
          return _vm.$set(item, "video_thumbnail", $event)
        },
        "update:picture_url": function($event) {
          return _vm.$set(item, "img_thumbnail", $event)
        }
      }
    }), _vm._v(" "), _c('b-form-file', {
      ref: "stepvideofile",
      refInFor: true,
      staticStyle: {
        "margin-top": "10px"
      },
      attrs: {
        "accept": ".mp4, .mov",
        "choose-label": (!item.video && !item.video_url) ? 'Choose video' : 'Remove video',
        "placeholder": item.video_url
      },
      on: {
        "change": function($event) {
          return _vm.handleVideoFileChange($event)
        }
      },
      nativeOn: {
        "click": function($event) {
          return _vm.clearStepVideo($event, item, index)
        }
      },
      model: {
        value: (item.video),
        callback: function($$v) {
          _vm.$set(item, "video", $$v)
        },
        expression: "item.video"
      }
    })], 1)] : _vm._e()], 2)])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "work-areas"
  }, [_c('h2', [_vm._v("Work areas and recurrence")]), _vm._v(" "), _c('div', [_vm._l((_vm.formData.workAreas), function(item, index) {
    return [_c('div', {
      staticClass: "row separator"
    }, [_vm._m(8, true), _vm._v(" "), _c('autocomplete', {
      attrs: {
        "suggest": _vm.formData.suggestArea,
        "anchor": "name",
        "process": _vm.processJSON,
        "on-select": _vm.getDataSearchArea,
        "additionalData": item
      }
    }), _vm._v(" "), _c('b-button', {
      staticClass: "col-md-2 offset-md-1 work-areas__btn",
      attrs: {
        "size": "",
        "variant": "primary"
      },
      on: {
        "click": function($event) {
          item.areaFromList = !item.areaFromList
        }
      }
    }, [_vm._v("Or select from list\n          ")]), _vm._v(" "), (item.areaFromList) ? _c('div', {
      staticClass: "col-md-3 offset-md-1"
    }, [_c('div', {
      staticClass: " work-areas__area-checkbox"
    }, [_c('area-checkbox', {
      attrs: {
        "type": "radio",
        "areas": _vm.areas,
        "baseId": 'areaCheckbox-' + index + '-',
        "selected": item.area
      },
      on: {
        "selectedAreaChanged": function($event) {
          return _vm.updateShiftsTableData()
        }
      },
      model: {
        value: (item.area),
        callback: function($$v) {
          _vm.$set(item, "area", $$v)
        },
        expression: "item.area"
      }
    })], 1)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      class: [(_vm.needFill && !item.area.length) ? 'has-danger' : '', 'line']
    }, [_vm._m(9, true), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "selected-areas"
    }, _vm._l((item.area), function(item) {
      return _c('p', [_vm._v(_vm._s(item.name))])
    }), 0)])]), _vm._v(" "), _c('p', {}, [_c('b', [_vm._v("When")])]), _vm._v(" "), _c('b-form-radio', {
      attrs: {
        "options": item.scheduler.type.options
      },
      model: {
        value: (item.scheduler.type.selected),
        callback: function($$v) {
          _vm.$set(item.scheduler.type, "selected", $$v)
        },
        expression: "item.scheduler.type.selected"
      }
    }), _vm._v(" "), (item.scheduler.type.selected == 0) ? [(item.scheduler.forever) ? _c('p', [_vm._v("The task will be recurring indefinitely.\n            "), _c('span', {
      staticClass: "underline pointer",
      on: {
        "click": function($event) {
          item.scheduler.forever = false
        }
      }
    }, [_vm._v("Would you like to set specific time period?")])]) : _vm._e(), _vm._v(" "), (!item.scheduler.forever) ? _c('div', {
      staticClass: "row align-items-baseline"
    }, [_c('p', {
      class: [(item.scheduler.forever) ? 'gray-text' : ''],
      staticStyle: {
        "margin": "0 15px"
      }
    }, [_c('b', [_vm._v("From date")])]), _vm._v(" "), _c('div', {
      class: [(_vm.needFill && !item.scheduler.fromDate) ? 'has-danger' : '', 'date', (item.scheduler.forever) ? 'hide' : '']
    }, [_c('datepicker', {
      attrs: {
        "bootstrapStyling": true,
        "format": "dd-MM-yyyy",
        "placeholder": item.scheduler.fromDate ? '' : 'DD-MM-YYYY',
        "clear-button": ""
      },
      model: {
        value: (item.scheduler.fromDate),
        callback: function($$v) {
          _vm.$set(item.scheduler, "fromDate", $$v)
        },
        expression: "item.scheduler.fromDate"
      }
    })], 1), _vm._v(" "), _c('p', {
      class: [(item.scheduler.forever) ? 'gray-text' : ''],
      staticStyle: {
        "margin": "0 15px"
      }
    }, [_c('b', [_vm._v("To date")])]), _vm._v(" "), _c('div', {
      class: [(_vm.needFill && !item.scheduler.toDate) ? 'has-danger' : '', 'date', (item.scheduler.forever) ? 'hide' : '']
    }, [_c('datepicker', {
      attrs: {
        "bootstrapStyling": true,
        "format": "dd-MM-yyyy",
        "placeholder": item.scheduler.toDate ? '' : 'DD-MM-YYYY',
        "clear-button": ""
      },
      model: {
        value: (item.scheduler.toDate),
        callback: function($$v) {
          _vm.$set(item.scheduler, "toDate", $$v)
        },
        expression: "item.scheduler.toDate"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-8 mt-1"
    }, [_c('b-tabs', {
      ref: "tabs",
      refInFor: true,
      model: {
        value: (item.scheduler.tabIndex),
        callback: function($$v) {
          _vm.$set(item.scheduler, "tabIndex", $$v)
        },
        expression: "item.scheduler.tabIndex"
      }
    }, [_c('b-tab', {
      attrs: {
        "title": "By shifts"
      }
    }, [_c('p', {
      class: ['mt-1', (_vm.needFill && item.scheduler.byShift.isNotChecked) ? 'text-danger' : '']
    }, [_c('b', [_vm._v("Select shifts")])]), _vm._v(" "), _c('b-table', {
      attrs: {
        "items": item.scheduler.byShift.items,
        "fields": item.scheduler.byShift.fields,
        "small": ""
      },
      scopedSlots: _vm._u([_vm._l((item.scheduler.byShift.fields), function(itemField, key) {
        return {
          key: key,
          fn: function(data) {
            return [(data.value) ? _c('span', {
              class: [item.scheduler.byShift.items[data.index][key].checked ? 'checkmark' : '', 'pointer'],
              on: {
                "click": function($event) {
                  return _vm.onClickShift(item.scheduler.byShift, key, data.index)
                }
              }
            }, [_vm._v(_vm._s(data.value.value))]) : _vm._e()]
          }
        }
      }), _vm._l((item.scheduler.byShift.fields), function(itemField, key) {
        return {
          key: 'HEAD_' + key,
          fn: function(data) {
            return [_vm._v("\n                      " + _vm._s(itemField.name) + "\n                      "), _c('div', {
              staticClass: "select-shift-table__header",
              on: {
                "click": function($event) {
                  return _vm.onSelectAllShifts(key, item.scheduler.byShift)
                }
              }
            }, [(!itemField.allSelected) ? _c('span', [_vm._v("Select all shifts")]) : _c('span', [_vm._v("Deselect shifts")])])]
          }
        }
      })], null, true)
    })], 1), _vm._v(" "), _c('b-tab', {
      attrs: {
        "title": "Weekly"
      }
    }, [_c('b-form', {
      attrs: {
        "inline": true
      }
    }, [_c('p', {
      staticClass: "mt-1"
    }, [_vm._v("\n                    Recur every\n                    "), _c('b-form-input', {
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "type": "number"
      },
      model: {
        value: (item.scheduler.weekly.recurWeek),
        callback: function($$v) {
          _vm.$set(item.scheduler.weekly, "recurWeek", $$v)
        },
        expression: "item.scheduler.weekly.recurWeek"
      }
    }), _vm._v(" week"), (!item.scheduler.weekly.is_once_per_week) ? _c('span', [_vm._v(" on")]) : _vm._e()], 1)]), _vm._v(" "), (item.scheduler.weekly.is_once_per_week) ? _c('p', {
      staticClass: "underline pointer",
      on: {
        "click": function($event) {
          item.scheduler.weekly.is_once_per_week = false
        }
      }
    }, [_vm._v("Select days of the week")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.weekDays), function(week, weekIndex) {
      return (!item.scheduler.weekly.is_once_per_week) ? _c('b-form-checkbox', {
        key: weekIndex,
        attrs: {
          "value": week.value
        },
        model: {
          value: (item.scheduler.weekly.selected),
          callback: function($$v) {
            _vm.$set(item.scheduler.weekly, "selected", $$v)
          },
          expression: "item.scheduler.weekly.selected"
        }
      }, [_vm._v("\n                    " + _vm._s(week.label) + "\n                  ")]) : _vm._e()
    }), _vm._v(" "), (!item.scheduler.weekly.is_once_per_week) ? _c('span', {
      staticClass: "underline pointer cancel_right",
      on: {
        "click": function($event) {
          item.scheduler.weekly.is_once_per_week = true
        }
      }
    }, [_vm._v("Cancel")]) : _vm._e()], 2), _vm._v(" "), _c('b-tab', {
      attrs: {
        "title": "Monthly"
      }
    }, [(item.scheduler.monthly.is_once_per_month) ? _c('div', [_c('b-form', {
      staticClass: "mt-1 ",
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "inline": true
      }
    }, [_c('p', [_vm._v("\n                      Recur every\n                      "), _c('b-form-input', {
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "type": "number"
      },
      model: {
        value: (item.scheduler.monthly.recurDay.month),
        callback: function($$v) {
          _vm.$set(item.scheduler.monthly.recurDay, "month", $$v)
        },
        expression: "item.scheduler.monthly.recurDay.month"
      }
    }), _vm._v("\n                      month\n                      ")], 1)]), _vm._v(" "), (item.scheduler.monthly.is_once_per_month) ? _c('p', {
      staticClass: "underline pointer",
      on: {
        "click": function($event) {
          item.scheduler.monthly.is_once_per_month = false
        }
      }
    }, [_vm._v("Select days of the month")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.scheduler.monthly.is_once_per_month),
        expression: "!item.scheduler.monthly.is_once_per_month"
      }]
    }, [_c('input', {
      attrs: {
        "id": 'monthlyType-' + index + '-1',
        "type": "radio",
        "name": 'monthlyType-' + index,
        "checked": ""
      }
    }), _vm._v(" "), _c('b-form', {
      staticClass: "mt-1",
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "inline": true
      }
    }, [_vm._v("\n                      Recur on\n                      "), _c('b-form-input', {
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "type": "number"
      },
      model: {
        value: (item.scheduler.monthly.recurDay.day),
        callback: function($$v) {
          _vm.$set(item.scheduler.monthly.recurDay, "day", $$v)
        },
        expression: "item.scheduler.monthly.recurDay.day"
      }
    }), _vm._v("\n                      day of every\n                      "), _c('b-form-input', {
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "type": "number"
      },
      model: {
        value: (item.scheduler.monthly.recurDay.month),
        callback: function($$v) {
          _vm.$set(item.scheduler.monthly.recurDay, "month", $$v)
        },
        expression: "item.scheduler.monthly.recurDay.month"
      }
    }), _vm._v("\n                      month\n                    ")], 1)], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.scheduler.monthly.is_once_per_month),
        expression: "!item.scheduler.monthly.is_once_per_month"
      }]
    }, [_c('input', {
      staticStyle: {
        "display": "inline"
      },
      attrs: {
        "id": 'monthlyType-' + index + '-2',
        "type": "radio",
        "name": 'monthlyType-' + index
      }
    }), _vm._v(" "), _c('b-form', {
      staticClass: "mt-1",
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "inline": true,
        "name": "bla"
      }
    }, [_vm._v("\n                      The\n                      "), _c('b-form-select', {
      attrs: {
        "options": _vm.weekNumbersItem
      },
      model: {
        value: (item.scheduler.monthly.recurWeekDay.every),
        callback: function($$v) {
          _vm.$set(item.scheduler.monthly.recurWeekDay, "every", $$v)
        },
        expression: "item.scheduler.monthly.recurWeekDay.every"
      }
    }), _vm._v(" "), _c('b-form-select', {
      attrs: {
        "options": _vm.weekdays
      },
      model: {
        value: (item.scheduler.monthly.recurWeekDay.weekDay),
        callback: function($$v) {
          _vm.$set(item.scheduler.monthly.recurWeekDay, "weekDay", $$v)
        },
        expression: "item.scheduler.monthly.recurWeekDay.weekDay"
      }
    }), _vm._v("\n                      of every "), _c('b-form-input', {
      staticStyle: {
        "width": "60px"
      },
      attrs: {
        "type": "number"
      },
      model: {
        value: (item.scheduler.monthly.recurWeekDay.month),
        callback: function($$v) {
          _vm.$set(item.scheduler.monthly.recurWeekDay, "month", $$v)
        },
        expression: "item.scheduler.monthly.recurWeekDay.month"
      }
    }), _vm._v("\n                      month\n                    ")], 1)], 1), _vm._v(" "), (!item.scheduler.monthly.is_once_per_month) ? _c('span', {
      staticClass: "underline pointer cancel_right",
      on: {
        "click": function($event) {
          item.scheduler.monthly.is_once_per_month = true
        }
      }
    }, [_vm._v("Cancel")]) : _vm._e()])], 1)], 1)])] : [_c('div', {
      staticClass: "row mt-1 align-items-baseline"
    }, [_vm._m(10, true), _vm._v(" "), _c('div', {
      class: [(_vm.needFill && !item.scheduler.oneDay.date) ? 'has-danger' : '', 'date']
    }, [_c('datepicker', {
      attrs: {
        "bootstrapStyling": true,
        "format": "dd-MM-yyyy",
        "placeholder": item.scheduler.oneDay.date ? '' : 'DD-MM-YYYY'
      },
      on: {
        "input": function($event) {
          return _vm.updateOneDayShifts(item.scheduler.oneDay)
        }
      },
      model: {
        value: (item.scheduler.oneDay.date),
        callback: function($$v) {
          _vm.$set(item.scheduler.oneDay, "date", $$v)
        },
        expression: "item.scheduler.oneDay.date"
      }
    })], 1)]), _vm._v(" "), _c('p', {
      class: ['mt-1']
    }, [_c('b', [_vm._v("At shift")])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticStyle: {
        "margin": "0 15px"
      }
    }, [_c('b-table', {
      attrs: {
        "items": item.scheduler.oneDay.item,
        "fields": item.scheduler.oneDay.field,
        "small": ""
      },
      scopedSlots: _vm._u([_vm._l((item.scheduler.oneDay.field), function(itemField, key) {
        return {
          key: key,
          fn: function(data) {
            return [(data.value) ? _c('span', {
              class: [item.scheduler.oneDay.items[data.index][key].checked ? 'checkmark' : '', 'pointer'],
              on: {
                "click": function($event) {
                  return _vm.onClickShift(item.scheduler.oneDay, key, data.index)
                }
              }
            }, [_vm._v(_vm._s(data.value.value))]) : _vm._e()]
          }
        }
      }), _vm._l((item.scheduler.oneDay.field), function(itemField, key) {
        return {
          key: 'HEAD_' + key,
          fn: function(data) {
            return [_vm._v("\n                  " + _vm._s(itemField.name) + "\n                  "), _c('div', {
              staticClass: "select-shift-table__header",
              on: {
                "click": function($event) {
                  return _vm.onSelectAllShifts(key, item.scheduler.oneDay)
                }
              }
            }, [(!itemField.allSelected) ? _c('span', [_vm._v("Select all shifts")]) : _c('span', [_vm._v("Deselect shifts")])])]
          }
        }
      })], null, true)
    })], 1)])], _vm._v(" "), _c('div', {
      staticClass: "row align-items-baseline"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [(index == _vm.formData.workAreas.length - 1) ? _c('b-button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (false),
        expression: "false"
      }],
      staticClass: "line",
      attrs: {
        "size": "",
        "variant": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.addOneMoreArea()
        }
      }
    }, [_vm._v("Add one more area and recurrence rule\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [(_vm.formData.workAreas.length > 1) ? _c('b-button', {
      staticClass: "line",
      attrs: {
        "size": "",
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.deleteOneArea(index)
        }
      }
    }, [_vm._v("Delete area and recurrence rule\n        ")]) : _vm._e()], 1)])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-right"
  }, [(!_vm.duplicate && _vm.taskId) ? _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.duplicateTask(true)
      }
    }
  }, [_vm._v("\n            Duplicate\n          ")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveTask(true)
      }
    }
  }, [_vm._v("\n            Save and add another\n          ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": function($event) {
        return _vm.saveTask()
      }
    }
  }, [_vm._v("\n            Save task\n          ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.deleteTask()
      }
    }
  }, [_vm._v("\n            Delete task\n          ")])], 1)])]), _vm._v(" "), _c('b-modal', {
    ref: "delete_task",
    attrs: {
      "title": ""
    },
    on: {
      "ok": function($event) {
        return _vm.taskMustDelete();
      }
    }
  }, [_vm._v("\n      You are about to delete this task. Are you sure?\n    ")])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 duplicat-warning"
  }, [_c('p', [_vm._v("Details are copied from the original. If you don't make any changes and save, the item will be duplicated!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', [_vm._v("Add a task on this page")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Title")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Description")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Assign to user role")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-3"
  }, [_vm._v("OR "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("upload a PDF file with task instructions.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2"
  }, [_c('b', [_vm._v("Step")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-1"
  }, [_c('b', [_vm._v("Order")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "col-md-2 align-baseline"
  }, [_c('b', [_vm._v("Search working area")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("Selected working area")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "0 15px"
    }
  }, [_c('p', [_c('b', [_vm._v("On date")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39e25b4e","hasScoped":false}!./src/components/taskConfig/taskConfig.component.html
// module id = 540
// module chunks = 1